import { render } from "./CreateAPIKeyModal.vue?vue&type=template&id=71b6717c&ts=true"
import script from "./CreateAPIKeyModal.vue?vue&type=script&lang=ts"
export * from "./CreateAPIKeyModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__